import { Radio } from 'react-aria-components';
import { cn } from '~/lib/utils';

type RadioOptionProps = {
  value: string;
  label: string;
};

export default function RadioOption({ value, label }: RadioOptionProps) {
  return (
    <Radio
      value={value}
      className={cn(
        'flex cursor-pointer select-none items-center gap-2.5 rounded-xl border p-5 text-sm text-body',
        'border-chip-border bg-chip-background',
        'data-selected:border-chip-border-selected data-selected:bg-chip-selected data-selected:text-chip-text-selected',
        'max-wide:p-4 compact:px-3 compact:py-2.5 compact:min-h-11 compact:text-[13px] compact:flex-auto',
      )}
    >
      {({ isSelected }) => (
        <>
          <div
            className={cn(
              'flex size-4 shrink-0 items-center justify-center rounded-full border-2',
              isSelected ? 'border-radio-accent' : 'border-input-border',
            )}
          >
            {isSelected && <div className="size-1.5 rounded-full bg-radio-accent" />}
          </div>
          {label}
        </>
      )}
    </Radio>
  );
}
